import {
  faUser,
  faSort,
  faSortUp,
  faSortDown,
  faSync,
  faEye,
  faBan,
  faTimes,
  faArrowLeft,
  faSave,
  faPlus,
  faPencilAlt,
  faBars,
  faThList,
  faUserPlus,
  faRoad,
  faTachometerAlt,
  faHeart,
  faList,
  faBell,
  faBook,
  faHdd,
  faFlag,
  faWrench,
  faLock,
  faCloud,
  faSignOutAlt,
  faSignInAlt,
  faCalendarAlt,
  faSearch,
  faTrashAlt,
  faAsterisk,
  faTasks,
  faHome,
  faClipboardCheck,
  faAddressBook,
  faFileAlt,
  faQuestionCircle,
  faPlusCircle,
  faInfoCircle,
  faExclamationTriangle,
  faThumbsUp,
  faEnvelope,
  faUnlock,
  faEdit,
  faUserMd,
} from '@fortawesome/free-solid-svg-icons';

export const fontAwesomeIcons = [
  faUser,
  faSort,
  faSortUp,
  faSortDown,
  faSync,
  faEye,
  faBan,
  faTimes,
  faArrowLeft,
  faSave,
  faPlus,
  faPencilAlt,
  faBars,
  faHome,
  faThList,
  faUserPlus,
  faRoad,
  faTachometerAlt,
  faHeart,
  faList,
  faBell,
  faTasks,
  faBook,
  faHdd,
  faFlag,
  faWrench,
  faLock,
  faCloud,
  faSignOutAlt,
  faSignInAlt,
  faCalendarAlt,
  faSearch,
  faTrashAlt,
  faAsterisk,
  faClipboardCheck,
  faAddressBook,
  faFileAlt,
  faQuestionCircle,
  faPlusCircle,
  faInfoCircle,
  faExclamationTriangle,
  faThumbsUp,
  faEnvelope,
  faUnlock,
  faEdit,
  faUserMd
];
